const statusMap: Record<string, { label: string; tone: string }> = {
  DRAFT: { label: '草稿', tone: 'neutral' },
  PENDING_REVIEW: { label: '待复核', tone: 'warning' },
  ACTIVE: { label: '生效中', tone: 'success' },
  PENDING_APPROVAL: { label: '待审批', tone: 'warning' },
  PENDING_ISSUANCE: { label: '待签发', tone: 'info' },
  APPROVED: { label: '已审批执行', tone: 'success' },
  REJECTED: { label: '已拒绝', tone: 'neutral' },
  PENDING: { label: '待生效', tone: 'info' },
  GRACE_PERIOD: { label: '宽限期', tone: 'warning' },
  EXPIRED: { label: '已过期', tone: 'danger' },
  REVOKED: { label: '已吊销', tone: 'neutral' },
  PENDING_ACTIVATION: { label: '待激活', tone: 'warning' },
  SUSPENDED: { label: '已停用', tone: 'neutral' },
  SUPERSEDED: { label: '已被修订替代', tone: 'neutral' },
  CANCELLED: { label: '已取消', tone: 'neutral' },
  DECOMMISSIONED: { label: '已退役', tone: 'danger' },
}

export function StatusBadge({ status, label }: { status: string, label?: string }) {
  const item = statusMap[status] || { label: status, tone: 'neutral' }
  return <span className={`status status--${item.tone}`}><i />{label || item.label}</span>
}
